function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["__scopeRadio", "name", "checked", "required", "disabled", "value", "onCheck"],
  _excluded2 = ["__scopeRadio", "forceMount"],
  _excluded3 = ["control", "checked", "bubbles"],
  _excluded4 = ["__scopeRadioGroup", "name", "defaultValue", "value", "required", "disabled", "orientation", "dir", "loop", "onValueChange"],
  _excluded5 = ["__scopeRadioGroup", "disabled"],
  _excluded6 = ["__scopeRadioGroup"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var $9yYIj$babelruntimehelpersextends = require("@babel/runtime/helpers/extends");
var $9yYIj$react = require("react");
var $9yYIj$radixuiprimitive = require("@radix-ui/primitive");
var $9yYIj$radixuireactcomposerefs = require("@radix-ui/react-compose-refs");
var $9yYIj$radixuireactcontext = require("@radix-ui/react-context");
var $9yYIj$radixuireactprimitive = require("@radix-ui/react-primitive");
var $9yYIj$radixuireactrovingfocus = require("@radix-ui/react-roving-focus");
var $9yYIj$radixuireactusecontrollablestate = require("@radix-ui/react-use-controllable-state");
var $9yYIj$radixuireactdirection = require("@radix-ui/react-direction");
var $9yYIj$radixuireactusesize = require("@radix-ui/react-use-size");
var $9yYIj$radixuireactuseprevious = require("@radix-ui/react-use-previous");
var $9yYIj$radixuireactpresence = require("@radix-ui/react-presence");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createRadioGroupScope", function () {
  return $240483839a8a76fd$export$c547093f11b76da2;
});
$parcel$export(module.exports, "RadioGroup", function () {
  return $240483839a8a76fd$export$a98f0dcb43a68a25;
});
$parcel$export(module.exports, "RadioGroupItem", function () {
  return $240483839a8a76fd$export$9f866c100ef519e4;
});
$parcel$export(module.exports, "RadioGroupIndicator", function () {
  return $240483839a8a76fd$export$5fb54c671a65c88;
});
$parcel$export(module.exports, "Root", function () {
  return $240483839a8a76fd$export$be92b6f5f03c0fe9;
});
$parcel$export(module.exports, "Item", function () {
  return $240483839a8a76fd$export$6d08773d2e66f8f2;
});
$parcel$export(module.exports, "Indicator", function () {
  return $240483839a8a76fd$export$adb584737d712b70;
});

/* -------------------------------------------------------------------------------------------------
 * Radio
 * -----------------------------------------------------------------------------------------------*/
var $ce74a64c62457efb$var$RADIO_NAME = 'Radio';
var _$9yYIj$radixuireactc = $9yYIj$radixuireactcontext.createContextScope($ce74a64c62457efb$var$RADIO_NAME),
  _$9yYIj$radixuireactc2 = _slicedToArray(_$9yYIj$radixuireactc, 2),
  $ce74a64c62457efb$var$createRadioContext = _$9yYIj$radixuireactc2[0],
  $ce74a64c62457efb$export$67d2296460f1b002 = _$9yYIj$radixuireactc2[1];
var _$ce74a64c62457efb$va = $ce74a64c62457efb$var$createRadioContext($ce74a64c62457efb$var$RADIO_NAME),
  _$ce74a64c62457efb$va2 = _slicedToArray(_$ce74a64c62457efb$va, 2),
  $ce74a64c62457efb$var$RadioProvider = _$ce74a64c62457efb$va2[0],
  $ce74a64c62457efb$var$useRadioContext = _$ce74a64c62457efb$va2[1];
var $ce74a64c62457efb$export$d7b12c4107be0d61 = /*#__PURE__*/$9yYIj$react.forwardRef(function (props, forwardedRef) {
  var __scopeRadio = props.__scopeRadio,
    name = props.name,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    required = props.required,
    disabled = props.disabled,
    _props$value = props.value,
    value = _props$value === void 0 ? 'on' : _props$value,
    onCheck = props.onCheck,
    radioProps = _objectWithoutProperties(props, _excluded);
  var _$9yYIj$react$useStat = $9yYIj$react.useState(null),
    _$9yYIj$react$useStat2 = _slicedToArray(_$9yYIj$react$useStat, 2),
    button = _$9yYIj$react$useStat2[0],
    setButton = _$9yYIj$react$useStat2[1];
  var composedRefs = $9yYIj$radixuireactcomposerefs.useComposedRefs(forwardedRef, function (node) {
    return setButton(node);
  });
  var hasConsumerStoppedPropagationRef = $9yYIj$react.useRef(false); // We set this to true by default so that events bubble to forms without JS (SSR)
  var isFormControl = button ? Boolean(button.closest('form')) : true;
  return /*#__PURE__*/$9yYIj$react.createElement($ce74a64c62457efb$var$RadioProvider, {
    scope: __scopeRadio,
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/$9yYIj$react.createElement($9yYIj$radixuireactprimitive.Primitive.button, $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({
    type: "button",
    role: "radio",
    "aria-checked": checked,
    "data-state": $ce74a64c62457efb$var$getState(checked),
    "data-disabled": disabled ? '' : undefined,
    disabled: disabled,
    value: value
  }, radioProps, {
    ref: composedRefs,
    onClick: $9yYIj$radixuiprimitive.composeEventHandlers(props.onClick, function (event) {
      // radios cannot be unchecked so we only communicate a checked state
      if (!checked) onCheck === null || onCheck === void 0 || onCheck();
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if radio is in a form, stop propagation from the button so that we only propagate
        // one click event (from the input). We propagate changes from an input so that native
        // form validation works and form events reflect radio updates.
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /*#__PURE__*/$9yYIj$react.createElement($ce74a64c62457efb$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name: name,
    value: value,
    checked: checked,
    required: required,
    disabled: disabled // We transform because the input is absolutely positioned but we have
    ,

    style: {
      transform: 'translateX(-100%)'
    }
  }));
});
/*#__PURE__*/
Object.assign($ce74a64c62457efb$export$d7b12c4107be0d61, {
  displayName: $ce74a64c62457efb$var$RADIO_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioIndicator
 * -----------------------------------------------------------------------------------------------*/
var $ce74a64c62457efb$var$INDICATOR_NAME = 'RadioIndicator';
var $ce74a64c62457efb$export$d35a9ffa9a04f9e7 = /*#__PURE__*/$9yYIj$react.forwardRef(function (props, forwardedRef) {
  var __scopeRadio = props.__scopeRadio,
    forceMount = props.forceMount,
    indicatorProps = _objectWithoutProperties(props, _excluded2);
  var context = $ce74a64c62457efb$var$useRadioContext($ce74a64c62457efb$var$INDICATOR_NAME, __scopeRadio);
  return /*#__PURE__*/$9yYIj$react.createElement($9yYIj$radixuireactpresence.Presence, {
    present: forceMount || context.checked
  }, /*#__PURE__*/$9yYIj$react.createElement($9yYIj$radixuireactprimitive.Primitive.span, $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({
    "data-state": $ce74a64c62457efb$var$getState(context.checked),
    "data-disabled": context.disabled ? '' : undefined
  }, indicatorProps, {
    ref: forwardedRef
  })));
});
/*#__PURE__*/
Object.assign($ce74a64c62457efb$export$d35a9ffa9a04f9e7, {
  displayName: $ce74a64c62457efb$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */
var $ce74a64c62457efb$var$BubbleInput = function $ce74a64c62457efb$var$BubbleInput(props) {
  var control = props.control,
    checked = props.checked,
    _props$bubbles = props.bubbles,
    bubbles = _props$bubbles === void 0 ? true : _props$bubbles,
    inputProps = _objectWithoutProperties(props, _excluded3);
  var ref = $9yYIj$react.useRef(null);
  var prevChecked = $9yYIj$radixuireactuseprevious.usePrevious(checked);
  var controlSize = $9yYIj$radixuireactusesize.useSize(control); // Bubble checked change to parents (e.g form change event)
  $9yYIj$react.useEffect(function () {
    var input = ref.current;
    var inputProto = window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
    var setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      var event = new Event('click', {
        bubbles: bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /*#__PURE__*/$9yYIj$react.createElement("input", $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({
    type: "radio",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps, {
    tabIndex: -1,
    ref: ref,
    style: _objectSpread(_objectSpread(_objectSpread({}, props.style), controlSize), {}, {
      position: 'absolute',
      pointerEvents: 'none',
      opacity: 0,
      margin: 0
    })
  }));
};
function $ce74a64c62457efb$var$getState(checked) {
  return checked ? 'checked' : 'unchecked';
}
var $240483839a8a76fd$var$ARROW_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
/* -------------------------------------------------------------------------------------------------
 * RadioGroup
 * -----------------------------------------------------------------------------------------------*/
var $240483839a8a76fd$var$RADIO_GROUP_NAME = 'RadioGroup';
var _$9yYIj$radixuireactc3 = $9yYIj$radixuireactcontext.createContextScope($240483839a8a76fd$var$RADIO_GROUP_NAME, [$9yYIj$radixuireactrovingfocus.createRovingFocusGroupScope, $ce74a64c62457efb$export$67d2296460f1b002]),
  _$9yYIj$radixuireactc4 = _slicedToArray(_$9yYIj$radixuireactc3, 2),
  $240483839a8a76fd$var$createRadioGroupContext = _$9yYIj$radixuireactc4[0],
  $240483839a8a76fd$export$c547093f11b76da2 = _$9yYIj$radixuireactc4[1];
var $240483839a8a76fd$var$useRovingFocusGroupScope = $9yYIj$radixuireactrovingfocus.createRovingFocusGroupScope();
var $240483839a8a76fd$var$useRadioScope = $ce74a64c62457efb$export$67d2296460f1b002();
var _$240483839a8a76fd$va = $240483839a8a76fd$var$createRadioGroupContext($240483839a8a76fd$var$RADIO_GROUP_NAME),
  _$240483839a8a76fd$va2 = _slicedToArray(_$240483839a8a76fd$va, 2),
  $240483839a8a76fd$var$RadioGroupProvider = _$240483839a8a76fd$va2[0],
  $240483839a8a76fd$var$useRadioGroupContext = _$240483839a8a76fd$va2[1];
var $240483839a8a76fd$export$a98f0dcb43a68a25 = /*#__PURE__*/$9yYIj$react.forwardRef(function (props, forwardedRef) {
  var __scopeRadioGroup = props.__scopeRadioGroup,
    name = props.name,
    defaultValue = props.defaultValue,
    valueProp = props.value,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    orientation = props.orientation,
    dir = props.dir,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    onValueChange = props.onValueChange,
    groupProps = _objectWithoutProperties(props, _excluded4);
  var rovingFocusGroupScope = $240483839a8a76fd$var$useRovingFocusGroupScope(__scopeRadioGroup);
  var direction = $9yYIj$radixuireactdirection.useDirection(dir);
  var _$9yYIj$radixuireactu = $9yYIj$radixuireactusecontrollablestate.useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _$9yYIj$radixuireactu2 = _slicedToArray(_$9yYIj$radixuireactu, 2),
    value = _$9yYIj$radixuireactu2[0],
    setValue = _$9yYIj$radixuireactu2[1];
  return /*#__PURE__*/$9yYIj$react.createElement($240483839a8a76fd$var$RadioGroupProvider, {
    scope: __scopeRadioGroup,
    name: name,
    required: required,
    disabled: disabled,
    value: value,
    onValueChange: setValue
  }, /*#__PURE__*/$9yYIj$react.createElement($9yYIj$radixuireactrovingfocus.Root, $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation: orientation,
    dir: direction,
    loop: loop
  }), /*#__PURE__*/$9yYIj$react.createElement($9yYIj$radixuireactprimitive.Primitive.div, $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({
    role: "radiogroup",
    "aria-required": required,
    "aria-orientation": orientation,
    "data-disabled": disabled ? '' : undefined,
    dir: direction
  }, groupProps, {
    ref: forwardedRef
  }))));
});
/*#__PURE__*/
Object.assign($240483839a8a76fd$export$a98f0dcb43a68a25, {
  displayName: $240483839a8a76fd$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupItem
 * -----------------------------------------------------------------------------------------------*/
var $240483839a8a76fd$var$ITEM_NAME = 'RadioGroupItem';
var $240483839a8a76fd$export$9f866c100ef519e4 = /*#__PURE__*/$9yYIj$react.forwardRef(function (props, forwardedRef) {
  var __scopeRadioGroup = props.__scopeRadioGroup,
    disabled = props.disabled,
    itemProps = _objectWithoutProperties(props, _excluded5);
  var context = $240483839a8a76fd$var$useRadioGroupContext($240483839a8a76fd$var$ITEM_NAME, __scopeRadioGroup);
  var isDisabled = context.disabled || disabled;
  var rovingFocusGroupScope = $240483839a8a76fd$var$useRovingFocusGroupScope(__scopeRadioGroup);
  var radioScope = $240483839a8a76fd$var$useRadioScope(__scopeRadioGroup);
  var ref = $9yYIj$react.useRef(null);
  var composedRefs = $9yYIj$radixuireactcomposerefs.useComposedRefs(forwardedRef, ref);
  var checked = context.value === itemProps.value;
  var isArrowKeyPressedRef = $9yYIj$react.useRef(false);
  $9yYIj$react.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if ($240483839a8a76fd$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
    };
    var handleKeyUp = function handleKeyUp() {
      return isArrowKeyPressedRef.current = false;
    };
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
  return /*#__PURE__*/$9yYIj$react.createElement($9yYIj$radixuireactrovingfocus.Item, $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !isDisabled,
    active: checked
  }), /*#__PURE__*/$9yYIj$react.createElement($ce74a64c62457efb$export$d7b12c4107be0d61, $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({
    disabled: isDisabled,
    required: context.required,
    checked: checked
  }, radioScope, itemProps, {
    name: context.name,
    ref: composedRefs,
    onCheck: function onCheck() {
      return context.onValueChange(itemProps.value);
    },
    onKeyDown: $9yYIj$radixuiprimitive.composeEventHandlers(function (event) {
      // According to WAI ARIA, radio groups don't activate items on enter keypress
      if (event.key === 'Enter') event.preventDefault();
    }),
    onFocus: $9yYIj$radixuiprimitive.composeEventHandlers(itemProps.onFocus, function () {
      var _ref$current;
      /**
      * Our `RovingFocusGroup` will focus the radio when navigating with arrow keys
      * and we need to "check" it in that case. We click it to "check" it (instead
      * of updating `context.value`) so that the radio change event fires.
      */
      if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
    })
  })));
});
/*#__PURE__*/
Object.assign($240483839a8a76fd$export$9f866c100ef519e4, {
  displayName: $240483839a8a76fd$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupIndicator
 * -----------------------------------------------------------------------------------------------*/
var $240483839a8a76fd$var$INDICATOR_NAME = 'RadioGroupIndicator';
var $240483839a8a76fd$export$5fb54c671a65c88 = /*#__PURE__*/$9yYIj$react.forwardRef(function (props, forwardedRef) {
  var __scopeRadioGroup = props.__scopeRadioGroup,
    indicatorProps = _objectWithoutProperties(props, _excluded6);
  var radioScope = $240483839a8a76fd$var$useRadioScope(__scopeRadioGroup);
  return /*#__PURE__*/$9yYIj$react.createElement($ce74a64c62457efb$export$d35a9ffa9a04f9e7, $parcel$interopDefault($9yYIj$babelruntimehelpersextends)({}, radioScope, indicatorProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($240483839a8a76fd$export$5fb54c671a65c88, {
  displayName: $240483839a8a76fd$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */
var $240483839a8a76fd$export$be92b6f5f03c0fe9 = $240483839a8a76fd$export$a98f0dcb43a68a25;
var $240483839a8a76fd$export$6d08773d2e66f8f2 = $240483839a8a76fd$export$9f866c100ef519e4;
var $240483839a8a76fd$export$adb584737d712b70 = $240483839a8a76fd$export$5fb54c671a65c88;